/**
 * Inhouse staff email domains.
 *
 * Split out of utils/Constants.js (roadmap Module 8) — Constants.js remains
 * a re-export shim until import sites migrate to "src/constants/inhouse".
 */
export const INHOUSE_DOMAINS = ["@inhouse.so", "@inhouse.app", "@inhouse.ai"];
